export default __webpack_public_path__ + "static/media/illu.e641ce8b.png";